import { Steps, StepsProps } from 'primereact/steps';
import React from 'react';
import './bi-steps.scss';

type Props = StepsProps & {};

export const BiSteps: React.FC<Props> = props => {
	return <Steps readOnly={true} {...props} />;
};
